var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 6,
  height: 10,
  viewBox: "0 0 6 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 5c0-.183.073-.366.22-.505L4.72.209a.776.776 0 0 1 1.06 0 .69.69 0 0 1 0 1.01L1.81 5l3.97 3.78a.69.69 0 0 1 0 1.01.776.776 0 0 1-1.06 0L.22 5.506A.7.7 0 0 1 0 5"
})));
export default SvgChevronColor;